/**
 * Textos do guia passo a passo (protótipo "Fluxo completo · do Início sem listas (B2) aos
 * contatos", Claude Design, 28/10/2026, e conhecimento/analises/PROPOSTA-GUIA-PRIMEIROS-LEADS.md).
 * O português fica como padrão no código (chaves `gp_*` em src/i18n/locales); en, es e fr vêm dos
 * arquivos de idioma, como no onboarding.
 */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const GUIA_PT = {
  // Os quatro marcos
  m1: 'Quem você quer encontrar',
  m2: 'Monte a busca',
  m3: 'Deixe a busca trabalhar',
  m4: 'Seus contatos',
  m1_sub: 'Uma busca pensada para o seu negócio.',
  m2_sub: 'O que procurar e onde, já preenchido.',
  m3_sub: 'Ela roda sozinha; você acompanha.',
  m4_sub: 'Telefone, WhatsApp e endereço de cada um.',
  step_of: '{{n}} de 4 · {{name}}',
  done: 'Concluído',
  done_sr: '(feito)',
  now_sr: '(agora)',

  // Convite e escolha da busca
  conv_title: 'Quer ajuda para encontrar seus primeiros clientes?',
  conv_text_where:
    'A gente faz junto a sua primeira busca por clientes em {{city}} e mostra onde ficam os contatos. Você pode sair quando quiser.',
  conv_text:
    'A gente faz junto a sua primeira busca por clientes e mostra onde ficam os contatos. Você pode sair quando quiser.',
  conv_plan: 'O que vamos fazer juntos',
  conv_no: 'Agora não',
  conv_yes: 'Sim, me mostre',
  esc_title: 'Por onde começamos?',
  esc_text:
    'Escolhemos 3 buscas para o seu perfil: {{profile}}. A primeira é a que mais combina com você.',
  esc_note: 'Usamos {{city}}, a cidade da sua conexão. Dá para trocar no passo seguinte.',
  esc_other: 'Quero buscar outra coisa',
  esc_go: 'Começar por esta',
  esc_open: 'Escolher a busca',
  esc_types_title: 'Que tipo de contato você procura?',
  esc_types_text: 'Escolha um tipo de busca. No passo seguinte, você diz o que procura e onde.',
  esc_profile_link: 'Contar sobre o meu negócio',
  k_loc: 'Negócios no Google Maps',
  k_tel: 'Telefones nas redes e sites',
  k_mail: 'Emails nas redes e sites',
  t_places: 'Telefone, site, redes e endereço das empresas no Google Maps.',
  t_phones: 'Profissionais e empresas que mostram o telefone no perfil.',
  t_emails: 'Endereços de email encontrados em sites e redes sociais.',

  // Cartão
  card_label: 'Guia passo a passo',
  card_more: 'Mais opções do guia',
  card_collapse: 'Recolher o guia',
  card_milestones: 'Marcos do guia',
  pill: 'Guia · {{n}} de 4',
  pill_label: 'Abrir o guia: {{text}}',
  menu_help: 'Preciso de ajuda',
  menu_restart: 'Começar de novo',
  menu_exit: 'Sair do guia',
  menu_corner: 'Voltar o guia para o canto',
  move: 'Mover o guia (use as setas)',
  toast_exit: 'O guia fica em Conta, quando quiser voltar.',
  undo: 'Desfazer',
  ok: 'Entendi',

  // Marco 2
  fields: 'Confira a busca. Explicamos os campos um a um.',
  skip: 'Pular explicações',
  pick_type: 'Escolha o tipo de busca no menu.',
  wait_window: 'O guia segue quando a busca abrir.',
  start: 'Clique em “Começar a captura”.',
  wait_start: 'O guia segue quando a busca começar.',
  closed: 'Você fechou a busca. Ela ficou guardada como você deixou.',
  reopen: 'Abrir a busca de novo',
  tab_notice: 'Leia o aviso e clique em “Abrir a aba e começar”.',
  ext_title: 'Falta uma peça no seu navegador.',
  ext_text:
    'A busca roda numa extensão do Chrome. É ela que pesquisa no Google por você. Instale e volte para esta aba.',
  ext_install: 'Instalar a extensão',
  license_title: 'Para buscar contatos novos, sua licença precisa estar ativa.',
  license_text: 'Ela terminou em {{date}}.',
  renew: 'Renovar',

  // Balões da busca
  b_term: 'O que procurar',
  b_term_places:
    'Já escrevemos “{{term}}”. Pode trocar ou acrescentar outros tipos de negócio. Cada um vira uma busca.',
  b_term_places_empty:
    'Escreva o tipo de negócio que você procura, como “dentista” ou “academia”. Cada um vira uma busca.',
  b_term_sites:
    'Escreva como o seu cliente se apresenta no perfil: a profissão, o cargo ou o segmento. Já escrevemos “{{term}}”.',
  b_term_sites_empty:
    'Escreva como o seu cliente se apresenta no perfil: a profissão, o cargo ou o segmento.',
  b_place: 'Onde procurar',
  b_place_city:
    'Começamos por {{city}}, a cidade da sua conexão. Se seus clientes estão em outro lugar, troque por outra cidade, um bairro ou um estado.',
  b_place_empty: 'Escreva a cidade, o bairro ou o estado onde estão os seus clientes.',
  b_reach: 'Até onde ir',
  b_reach_text:
    'A busca também olha os arredores de cada lugar. Mais alcance traz mais negócios e leva mais tempo.',
  b_sources: 'Onde procurar',
  b_sources_text:
    'Escolha as redes sociais ou os sites onde o seu cliente aparece. Pode acrescentar outros.',
  b_area: 'De que região',
  b_area_text: 'Deixe todos os códigos de área ou escolha a sua região.',
  b_start: 'Tudo certo?',
  b_start_text: 'Clique em “Começar a captura” para a busca começar.',

  // Marco 3
  running: 'A busca está rodando na outra aba.',
  running_text:
    'Pode fazer outra coisa enquanto isso. Quando ela terminar, clique em “Ver leads” lá.',
  count_one: 'contato até agora',
  count_other: 'contatos até agora',
  stuck_title: 'Parece parado?',
  stuck_text:
    'Olhe a aba da busca: o Google pode estar pedindo uma verificação. Resolva lá, e a busca continua sozinha.',
  empty: 'Desta vez a busca não trouxe contatos.',
  empty_text:
    'Isso acontece com termos muito específicos ou lugares pequenos. Tente outro termo, mais lugares ou mais alcance.',
  adjust: 'Ajustar a busca',
  tab_closed: 'A aba da busca foi fechada.',
  tab_closed_text: 'Os contatos encontrados até aqui estão salvos.',
  resume: 'Continuar a busca',

  // Marco 4
  trial: 'Um aviso sobre o teste.',
  trial_text:
    'No teste, os 5 primeiros contatos de cada lista aparecem completos. Os outros ficam embaralhados até você contratar.',
  list_arrived: 'Sua lista chegou: {{n}} contatos.',
  list_arrived_one: 'Sua lista chegou: 1 contato.',
  see_list: 'Ver minha lista',
  open_list: 'Abra a sua lista nova.',
  wait_list: 'O guia segue quando a lista abrir.',
  b_list_text: 'Clique para ver.',

  // Fim
  end_title: 'Pronto: você tem {{n}} contatos de {{term}}.',
  end_title_one: 'Pronto: você tem 1 contato de {{term}}.',
  end_title_plain: 'Pronto: você já tem seus primeiros contatos.',
  end_title_where: 'Pronto: você tem {{n}} contatos de {{term}} em {{place}}.',
  end_title_where_one: 'Pronto: você tem 1 contato de {{term}} em {{place}}.',
  end_text: 'Quando quiser mais, é só buscar de novo, quantas vezes precisar.',
  end_tip_enrich: 'Na lista, “Enriquecer dados” procura também o email e o CNPJ dos negócios.',
  end_tip_trial: 'Para ver todos os contatos completos, veja os planos.',
  see_plans: 'Ver os planos',
  new_search: 'Fazer outra busca',
  close_guide: 'Fechar o guia',

  // Balão do menu Conta
  b_account: 'O guia fica aqui',
  b_account_text: 'Em Conta, quando você quiser.',

  // Menu Conta
  menu_title: 'Guia passo a passo',
  menu_sub: 'Da primeira busca aos seus contatos',
  menu_continue: 'Continuar o guia',
  menu_stopped: 'Você parou em: {{name}}',

  // Início sem listas (B2)
  b2_title: 'Por onde você quer começar?',
  b2_text: 'Escolha um tipo de captura. Os outros continuam aqui para depois.',
  b2_places:
    'Telefone, site, redes e endereço das empresas no <b>Google Maps</b>. Você diz o tipo de negócio e a cidade.',
  b2_phones:
    'Números encontrados em <b>sites e redes sociais</b>. Você diz o que procura, como “arquiteto”.',
  b2_emails:
    'Endereços encontrados em <b>sites e redes sociais</b>. Você diz o que procura e de quais provedores.',
  b2_or: 'ou',
  b2_help_title: 'Quer ajuda para começar?',
  b2_help_text: 'Fazemos com você a primeira busca e mostramos onde ficam os contatos.',
  b2_help_go: 'Começar o guia',
  b2_types: 'Tipos de captura',
} as const;

export type GuiaKey = keyof typeof GUIA_PT;

export function useGuiaText() {
  const { t, i18n } = useTranslation();
  const lang = (i18n?.language ?? 'pt').slice(0, 2);
  const tx = useCallback(
    (key: GuiaKey, vars?: Record<string, string | number>): string =>
      t(`gp_${key}`, {
        defaultValue: GUIA_PT[key],
        ...vars,
        interpolation: { escapeValue: false },
      }) as string,
    [t],
  );
  return { tx, lang };
}
